import { cn } from '@common/utils/cn';

export function Divider({ onWhite = false, className }: { onWhite?: boolean; className?: string }) {
  return (
    <div
      className={cn('border-t', onWhite ? 'border-t-lightGrey' : 'border-t-mediumGrey', className)}
    />
  );
}
